<template>
  <div class="stage stage-4">
    <div class="stage-header">
      <h3>04: PICTURES</h3>
    </div>
    <div class="stage-body">
      <div class="pictures">
        <p>{{totalImagesCount}}/1 Pictures Added</p> 
        <div class="picture-option dropbox default">
          <input
            type="file"
            @change="
              filesChange($event.target.files, 'image1');
              fileCount = $event.target.files.length;
            "
            accept="image/*"
            class="input-file"
          />
          <img class="default-img" v-if="preivewImage1 == ''" id="preview" src="../../assets/add_photo.png" />
          <img v-if="preivewImage1 != ''" id="preview" :src="preivewImage1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PictureDetails",

  methods: {
    filesChange(fileList) {
      this.preivewImage1 = URL.createObjectURL(fileList[0]);
      this.$store.commit('activity/setFilesToUpload', [fileList[0]]);
    },
  },

  computed: {
    totalImagesCount() {
      let i = 0;
      if (this.preivewImage1 !== '') i++;

      return i;
    },

    preivewImage1: {
      get () {
        return this.$store.state.activity.preivewImage1
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'preivewImage1'})
      }
    },
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.stage {
  width: 100%;
  padding-bottom: $spacing-base;

  .stage-header {
    padding: $spacing-base;
    display: flex;
    h3 {
      font-size: 14px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: white;
    }
  }

  .stage-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $spacing-base;

    .activity-details {
      max-width: 600px;
      
      p {
        color: $sec4;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        margin: 0;
      }

      .slider {
        margin-top: $spacing-base;
      }
    }

    .details {
      padding: $spacing-base;
      padding-top: 0;
      display: flex;
      flex-direction: column;

      .detail-row {
        display: flex;
        margin-top: $spacing-base;
        flex-direction: row;
        gap: $spacing-base;

        .detail-col {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }

      label {
        font-weight: 500;
        font-size: 14px;
        color: $sec5;
        margin-top: $spacing-base;
      }

      label:first-of-type {
        margin-top: 0;
      }
    }

    .section-header {
      display: flex;
      flex-direction: row;
      padding: $spacing-base;
      h3 {
        margin: 0;
        padding: 0;
        font-weight: 500;
        color: $sec0;
        font-size: 1em;
      }
    }
  }
}

.error {
  border: 1px solid $red1 !important;
}

.error-text {
  color: $red1 !important;
}

a {
  color: $blue;
  font-size: 0.8em;
  cursor: pointer;
  user-select: none;
  margin-left: $spacing_base;
  margin-bottom: $spacing_base;
}

.pictures {
  p {
    font-size: 14px;
    color: $sec5;
    font-weight: 500;
    margin-left: $spacing-base;
    margin-top: 0;
  }
}

.default {
  float: left;
  .default-img {
    width: 20px;
    height: 20px;
    border-radius: 200px;
    padding: 30px;
    background: $sec0;
  }
}
</style>
